import {
  useState,
  useEffect,
  useRef,
  useMemo,
  useImperativeHandle,
  forwardRef,
} from "react";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import CameraComponent from "../ReusableComponents/Camera";
import { mainTable } from "../css/Common";
import FileUpload from "../ReusableComponents/FileUpload";
import { BindAPI, IUDAPI } from "../services/APIConnection";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import RadioButton from "../ReusableComponents/RadioButton";
import Loader from "../ReusableComponents/Loader";

const Checkinpopup = forwardRef(
  (
    {
      data,
      data1,
      data2,
      data3,
      data4,
      flag,
      setpopUpOpen,
      BindGetEnquiryValues,
      isLoading,
    },
    ref
  ) => {
    useEffect(() => {
      console.log("Received in popup: ", data, data1, data2, data3, data4);
    }, [data, data1]);

    const [tableData, setTableData] = useState([]);
    const [formData, setFormData] = useState({});
    const [formErrors, setFormErrors] = useState({});
    const [touchedFields, setTouchedFields] = useState({});
    const [errors, setErrors] = useState({});
    const [genderOptions, setGenderOptions] = useState([]);
    const [idproofOptions, setIdproofOptions] = useState([]);
    const [paymentTypeOptions, setPaymentTypeOptions] = useState([]);
    const [relationshipOptions, setRelationshipOptions] = useState([]);
    const [isLoadings, setIsLoadings] = useState(false);
    const [fileClear, setFileClear] = useState(false);
    useEffect(() => {
      BindCheckInDDDatas();
    }, []);

    const BindCheckInDDDatas = async () => {
      try {
        const response = await BindAPI("CheckInAPI/BindCheckInDDDatas");

        if (!response?.data) {
          resetDropdowns();
          return;
        }

        const { Table, Table1, Table2, Table3 } = response.data;

        setGenderOptions(mapOptions(Table, "MstGenderId", "Gender"));
        setIdproofOptions(mapOptions(Table1, "MstIdProofId", "IdProof"));
        setPaymentTypeOptions(
          mapOptions(Table2, "MstPaymentTypeId", "PaymentTypeId")
        );
        setRelationshipOptions(
          mapOptions(Table3, "MstRelationshipId", "Relationship")
        );
      } catch (error) {
        console.error("Failed to fetch dropdown data:", error);
        resetDropdowns();
      }
    };

    
    const mapOptions = (table = [], valueKey, labelKey) =>
      table.map((item) => ({
        value: item?.[valueKey],
        label: item?.[labelKey],
      }));

    const resetDropdowns = () => {
      setGenderOptions([]);
      setIdproofOptions([]);
      setPaymentTypeOptions([]);
      setRelationshipOptions([]);
    };
    
    useEffect(() => {
      if (data3?.length > 0) {
        let updatedData = [];

        data3.forEach((room) => {
          const numAdults = Number(room.numberofadults) || 0;
          const numChildren = Number(room.numberofchildren) || 0;
          const numAdditionalAdults = Number(room.CheckInAdditionalAdults) || 0;
          const numAdditionalChildren =
            Number(room.CheckInAdditionalChildren) || 0;
          const totalGuests =
            numAdults +
            numChildren +
            numAdditionalAdults +
            numAdditionalChildren;

          // Split into multiple rooms if multiple SelectedRoomIds
          const roomIds = (room.SelectedRoomIds || "")
            .split(",")
            .map((id) => parseInt(id.trim(), 10))
            .filter(Boolean);

          roomIds.forEach((roomId) => {
            const matchedGuests = data4.filter((g) => g.MstRoomId === roomId);

            const guestList = Array.from({ length: totalGuests }, (_, i) => {
              const guest = matchedGuests[i] || {};

              let isChild = false;

              if (i < numAdults) {
                // Normal adults
                isChild = false;
              } else if (i < numAdults + numChildren) {
                // Normal children
                isChild = true;
              } else if (i < numAdults + numChildren + numAdditionalAdults) {
                // Additional adults
                isChild = false;
              } else {
                // Additional children
                isChild = true;
              }

              return {
                guestName: guest.GuestName || "",
                gender: guest.Gender || "",
                age: guest.Age || "",
                relationship: guest.Relationship || "",
                idProofType: guest.IDProofType || "",
                idProofNumber: guest.IDProofNumber || "",
                Photo1: guest.Photo || "",
                isChild,
                TxnEnquiryChildId: room.TxnEnquiryChildId,
                MstRoomTypeId: room.RoomTypeId,
                MstRoomId: roomId,
                TxnEnquiryCheckInChildId:
                  guest.CheckOutStatus != 1
                    ? guest.TxnEnquiryCheckInChildId
                    : "",
                isSelectedValue: 0,
                isSelected: guest.CheckOutStatus == 1,
                disabled: guest.CheckOutStatus == 1,
                photoUploadMode: 2,
              };
            });

            updatedData.push({
              ...room,
              MstRoomId: roomId,
              // AvailableRoomsId: "", // reset
              guestList,
              additionalDetails: {
                charges: room.CheckInAdditionalCharges,
                adultname: room.CheckInAdditionalAdults,
                childernname: room.CheckInAdditionalChildren,
              },
            });
          });
        });

        setTableData(updatedData);
      } else {
        setTableData([]);
      }
    }, [data2, data3, data4]);
    // Step 2: Group tableData by RoomTypeId for tariff table
    const tableDataGrouped = Object.values(
      tableData.reduce((acc, room) => {
        if (!acc[room.RoomTypeId]) {
          acc[room.RoomTypeId] = { ...room };
        } else {
          // Combine totals if same RoomTypeId
          // acc[room.RoomTypeId].Numberofrooms += room.Numberofrooms || 0;
          // acc[room.RoomTypeId].numberofadults += room.numberofadults || 0;
          // acc[room.RoomTypeId].numberofchildren += room.numberofchildren || 0;
          acc[room.RoomTypeId].amount += room.amount || 0;
        }
        return acc;
      }, {})
    );
    const groupedData = Object.values(
      tableData.reduce((acc, room, idx) => {
        // canonical group = first id in SelectedRoomIds (fallback to room.MstRoomId)
        const ids = String(room.SelectedRoomIds || "")
          .split(",")
          .map((s) => Number(s.trim()))
          .filter(Boolean);
        const canonicalId = ids.length ? ids[0] : room.MstRoomId;

        // skip rows that belong to non-canonical MstRoomId (removes the 32 copy)
        if (room.MstRoomId !== canonicalId) return acc;

        if (!acc[canonicalId]) {
          acc[canonicalId] = {
            MstRoomId: canonicalId,
            RoomType: room.RoomType,
            rooms: [],
            _seen: new Set(),
          };
        }

        // avoid duplicates inside the group by TxnEnquiryChildId
        if (!acc[canonicalId]._seen.has(room.TxnEnquiryChildId)) {
          acc[canonicalId].rooms.push({ ...room, originalIndex: idx });
          acc[canonicalId]._seen.add(room.TxnEnquiryChildId);
        }

        return acc;
      }, {})
    ).map((g) => {
      // clean helper field
      const { _seen, ...rest } = g;
      return rest;
    });

    console.log("groupedData", groupedData);
    useEffect(() => {
      const updatedData = tableData.map((room) => {
        const numAdults = Number(room.numberofadults) || 0;
        const numChildren = Number(room.numberofchildren) || 0;
        const totalGuests = numAdults + numChildren;

        let guestList = room.guestList || [];

        // Adjust length
        if (guestList.length < totalGuests) {
          // Add empty guest entries
          const extraGuests = Array.from(
            { length: totalGuests - guestList.length },
            (_, i) => ({
              guestName: "",
              gender: "",
              age: "",
              relationship: "",
              idProofType: "",
              idProofNumber: "",
              Photo1: "",
              isChild: guestList.length + i >= numAdults,
              TxnEnquiryChildId: room.TxnEnquiryChildId,
              MstRoomTypeId: room.RoomTypeId,
              MstRoomId: room.MstRoomId,
            })
          );
          guestList = [...guestList, ...extraGuests];
        } else if (guestList.length > totalGuests) {
          guestList = guestList.slice(0, totalGuests);
        }

        // Update isChild flags
        guestList = guestList.map((g, i) => ({
          ...g,
          isChild: i >= numAdults,
        }));

        return {
          ...room,
          guestList,
        };
      });

      setTableData(updatedData);
    }, [
      tableData
        .map((r) => `${r.numberofadults}-${r.numberofchildren}`)
        .join(","),
    ]);
    const handleDamageRadioChange = (roomIndex, value) => {
      setTableData((prev) => {
        const updated = [...prev];
        updated[roomIndex].photoUploadMode = value;
        return updated;
      });


    };

    
    const handleGuestShowImage = (roomIndex, fileUrl) => {
      setTableData((prev) => {
        const updated = [...prev];
        if (updated[roomIndex]) {
          updated[roomIndex] = {
            ...updated[roomIndex],
            Photo1: fileUrl, // ✅ update the uploaded file URL
          };
        }
        return updated;
      });
    };
   const handleRoomGuestChange = (
  roomIndex,
  listKey,
  guestIndex,
  field,
  value
) => {
  setTableData(prev => {
    const updated = [...prev];

    // Ensure room exists
    if (!updated[roomIndex]) return prev;

    // Ensure list exists
    updated[roomIndex][listKey] = [
      ...(updated[roomIndex][listKey] || [])
    ];

    // Ensure guest object exists
    updated[roomIndex][listKey][guestIndex] = {
      ...(updated[roomIndex][listKey][guestIndex] || {})
    };

    // Set field
    updated[roomIndex][listKey][guestIndex][field] = value;

    return updated;
  });
};


    const handleRoomAdditionalChange = (index, key, value) => {
      const updatedRooms = [...tableData];
      const room = updatedRooms[index];

      if (!room.additionalDetails) {
        room.additionalDetails = {};
      }

      // Store numeric value for charges
      room.additionalDetails[key] =
        key === "charges" ? (value === "" ? "" : Number(value)) : value;

      const numAdditionalAdults =
        parseInt(room.additionalDetails.adultname || 0, 10) || 0;
      const numAdditionalChildren =
        parseInt(room.additionalDetails.childernname || 0, 10) || 0;

      const staticGuests = room.guestList?.filter((g) => !g.isDynamic) || [];

      const newAdultGuests = Array.from(
        { length: numAdditionalAdults },
        () => ({
          guestName: "",
          gender: "",
          age: "",
          relationship: "",
          idProofType: "",
          idProofNumber: "",
          Photo1: "",
          isChild: false,
          isDynamic: true,
          TxnEnquiryChildId: room.TxnEnquiryChildId,
          MstRoomTypeId: room.RoomTypeId,
          MstRoomId: room.MstRoomId,
        })
      );

      const newChildGuests = Array.from(
        { length: numAdditionalChildren },
        () => ({
          guestName: "",
          gender: "",
          age: "",
          relationship: "",
          idProofType: "",
          idProofNumber: "",
          Photo1: "",
          isChild: true,
          isDynamic: true,
          TxnEnquiryChildId: room.TxnEnquiryChildId,
          MstRoomTypeId: room.RoomTypeId,
          MstRoomId: room.MstRoomId,
        })
      );

      room.guestList = [...staticGuests, ...newAdultGuests, ...newChildGuests];

      setTableData(updatedRooms); // triggers useMemo → totalAmount recalculates
    };

    const handleClearAdditionalDetails = (roomIndex) => {
      setTableData((prev) => {
        const updated = [...prev];
        updated[roomIndex].additionalDetails = {
          adultname: "",
          childernname: "",
          charges: "",
        };
        return updated;
      });
    };

    const handleClearGuest = (roomIndex, guestIndex) => {
      setTableData((prev) => {
        const updated = [...prev];
        updated[roomIndex].guestList.splice(guestIndex, 1);
        return updated;
      });
    };

    useEffect(() => {
      if (data) {
        debugger;
        const checkInDate =
          flag === 2 || flag === 1 || flag === 3 || data.CheckInDate
            ? new Date(data.CheckInDate)
            : new Date(); // current datetime
        setFormData({
          enquiryDate: data.EnquiryDate || null,
          enquiryId: data.EnquiryNo || null,
          fullName: data.GuestName || null,
          bookingId: data.BookingNo || null,
          date: checkInDate ? checkInDate.toISOString().split("T")[0] : null, // 👉 "2025-08-13"
          time: checkInDate ? checkInDate.toTimeString().split(" ")[0] : null, // 👉 "17:59:00"
          totalAmount:
            flag == 2
              ? parseInt(data.CheckInTotalAmount, 10) || null
              : parseInt(data.BookingTotalAmount, 10) || null,
          receivedAmout:
          //  flag == 2 ? 
            parseInt(data.CheckInReceivedAmount, 10) || 0 ,
          //  : 0,
          balanceAmount:
            flag == 2
              ? parseInt(data.CheckInBalanceAmount, 10) || null
              : parseInt(data.BookingBalanceAmount, 10) || null,
          paymentmethod: data.PaymentType || null,
          referencenumber: data.PaymentRefNumber || null,
          showImage: data.ShowImage,
          bookingTotalAmount: parseInt(data.BookingTotalAmount, 10) || null,
          bookingReceivedAmount:
            parseInt(data.BookingReceivedAmount, 10) || null,
          bookingBalanceAmount: parseInt(data.BookingBalanceAmount, 10) || null,
        });
      }
    }, [data]);
    const handleShowImage = (showImage) => {
      // showImage &&
      setFormData({
        ...formData,
        showImage: showImage || "",
      });
      setFormErrors({
        ...formErrors,
        showImageError: "",
      });
    };
    const validateField = (name, value, form = formData) => {
      let error = "";

      switch (name) {
        case "date":
          if (!value) {
            error = "Check-in date is required.";
          } else if (dayjs(value).isAfter(dayjs(), "day")) {
            error = "Check-in date cannot be in the future.";
          }
          break;

        case "time":
          if (!value) error = "Check-in time is required.";
          break;
        default:
          break;
      }

      return error;
    };

    const handleInputChangeForm = (e) => {
      const { name, value } = e.target;

      const updatedForm = {
        ...formData,
        [name]: value,
      };

      // Calculate balance (never show negative)
      const total =
        parseFloat(totalAmount || 0) - formData.bookingReceivedAmount;

      let received =
        name === "receivedAmout" ? value : updatedForm.receivedAmout || 0;

      // ✅ If cleared → use previous balance
      if (received === "" || received == null) {
        updatedForm.balanceAmount = total;
        updatedForm.receivedAmout = 0;
      } else {
        received = parseFloat(received) || 0;

        // ✅ Prevent received > total
        if (received > total) {
          received = total;
        }

        updatedForm.receivedAmout = received;
        updatedForm.balanceAmount = total - received;
      }

      // Combine date + time
      if (
        (name === "date" || name === "time") &&
        updatedForm.date &&
        updatedForm.time
      ) {
        const combined = `${updatedForm.date} ${updatedForm.time}`;
        const formatted = dayjs(combined).format("YYYY-MM-DD HH:mm:ss");

        if (dayjs(formatted).isAfter(dayjs())) {
          updatedForm.checkInDateTime = "";
        } else {
          updatedForm.checkInDateTime = formatted;
        }
      }

      // Real-time error only if already touched
      const updatedErrors = { ...formErrors };
      if (touchedFields[name]) {
        const error = validateField(name, value, updatedForm);
        if (error) {
          updatedErrors[name] = error;
        } else {
          delete updatedErrors[name];
        }
      }

      setFormData(updatedForm);
      setFormErrors(updatedErrors);
    };

    const handleInputChangeTable = (e, rowIndex) => {
      const { name, value } = e.target;

      const updatedTable = [...tableData];
      const updatedRow = { ...updatedTable[rowIndex], [name]: value };

      const specialTariff = parseFloat(updatedRow.specialtariff || 0);
      const numberOfRooms = parseInt(updatedRow.Numberofrooms || 0);

      const total = specialTariff * numberOfRooms;
      updatedRow.total = isNaN(total) ? "" : total.toFixed(2);

      updatedTable[rowIndex] = updatedRow;
      setTableData(updatedTable);
    };

    const handleBlur = (e) => {
      const { name, value } = e.target;

      setTouchedFields((prev) => ({ ...prev, [name]: true }));

      const error = validateField(name, value);
      setFormErrors((prev) => ({
        ...prev,
        [name]: error ? error : undefined,
      }));
    };

    // const totalAmount = useMemo(() => {
    //   return tableData
    //     .reduce((sum, row) => {
    //       const total = parseFloat(row.total) || 0;
    //       const charges = parseFloat(row.additionalDetails?.charges) || 0;
    //       return sum + total + charges;
    //     }, 0)
    //     .toFixed(2);
    // }, [tableData]);

    const totalAmount = useMemo(() => {

      return tableDataGrouped.reduce((sum, row) => {
    
        return sum +
          (parseFloat(row.specialtariff || 0) *
           parseInt(row.Numberofrooms || 0));
    
      }, 0).toFixed(2);
    
    }, [tableDataGrouped]);

    // useEffect(() => {
    //   const received = parseFloat(formData.bookingReceivedAmount) || 0;
    //   const balance =
    //     parseFloat(totalAmount) -
    //       received -
    //       parseFloat(formData.receivedAmout) || 0;

    //   setFormData((prev) => ({
    //     ...prev,
    //     totalAmount: totalAmount,
    //     balanceAmount: balance.toFixed(2),
    //   }));
    // }, [totalAmount, formData.bookingReceivedAmount]);

    const checkInTotalAmount = useMemo(() => {

      if (flag == 2 || flag == 3)
      {
        return parseFloat(data?.CheckInTotalAmount || 0).toFixed(2);
      }
    
      return parseFloat(data?.BookingBalanceAmount || 0).toFixed(2);
    
    }, [data, flag]);

    useEffect(() => {

      const total = parseFloat(checkInTotalAmount) || 0;
      const received = parseFloat(formData.receivedAmout) || 0;
    
      const balance = total - received;
    
      setFormData(prev => ({
        ...prev,
        totalAmount: total.toFixed(2),
        balanceAmount: balance.toFixed(2)
      }));
    
    }, [checkInTotalAmount, formData.receivedAmout]);

    const handleInputChange = (e, index) => {
      const { name, value } = e.target;
      const updatedRows = [...tableData];
      updatedRows[index][name] = value;
      setTableData(updatedRows);
    };
    useImperativeHandle(ref, () => ({
      childFunction() {
        handleSubmit(0, flag ? flag : 1);
      },
      childCancelFunction() {
        cancel();
      },
    }));
    const cancel = () => {
      setFileClear(true);
      BindGetEnquiryValues();
      setFormData({
        enquiryDate: null,
        enquiryId: null,
        bookingId: null,
        checkInDateTime: "",
        totalAmount: null,
        receivedAmout: null,
        balanceAmount: null,
        paymentmethod: null,
        referencenumber: null,
        showImage: null,
      });
      setFormErrors({});
      setTableData([]);
      setpopUpOpen?.(false);
      setIsLoadings(false);
    };
    const createdBy = sessionStorage.getItem("createdBy");
    const handleSubmit = async (items, flag) => {
      debugger;
      setIsLoadings(true);

      console.log("tableData:", tableData, JSON.stringify(tableData));
      const requiredFields = ["date", "time"];

      let newErrors = {};
      let hasError = false;

      requiredFields.forEach((field) => {
        const error = validateField(field, formData[field]);
        if (error) {
          newErrors[field] = error;
          hasError = true;
        }
      });

      if (hasError) {
        setFormErrors(newErrors); // ✅ this is the state your JSX uses
        toast.error("Please fix the highlighted errors before submitting.", {
          duration: 3000,
          position: "top-center",
        });
        setIsLoadings(false);
        return;
      }

      // ✅ Clear previous errors when everything is valid
      setFormErrors({});

      // Step 2: Proceed if no errors
      console.log("tableData:", tableData, JSON.stringify(tableData));

      const checkInDate =
        formData?.date && formData?.time
          ? `${formData.date}T${formData.time}`
          : null;

      const data = {
        enquiryId: formData?.enquiryId,
        checkInDate: checkInDate, // Must be valid ISO 8601 string or null
        checkInTotalAmount: parseFloat(formData?.totalAmount || 0),
        checkInReceivedAmount: parseFloat(formData?.receivedAmout || 0),
        checkInBalanceAmount: parseFloat(formData?.balanceAmount || 0),
        checkInPaymentType: formData?.paymentmethod || null,
        checkInPaymentReferenceNumber: formData?.referencenumber || null,
        checkInData: JSON.stringify(tableData), // Must be valid JSON string
        checkInPaymentReference: formData?.showImage || null,
        flag: flag,
        createdBy: parseInt(createdBy, 10),
      };
      console.log("data", data);
      const response = await IUDAPI(data, "CheckInAPI/IUDCheckIn");
      if (flag == 1) {
        if (response.data.Table[0].Result === "S") {
          toast.success("Check-In Successful", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Failed to Check-In", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else if (flag == 2) {
        if (response.data.Table[0].Result === "S") {
          toast.success("Data Updated Successful", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Failed to Data Updated", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else if (flag == 3) {
        if (response.data.Table[0].Result === "S") {
          toast.success("Data Deleted Successful", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Failed to Data Deleted", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      }
    };

    const selectedDate = new Date(formData.date);
    const today = new Date();

    // Clear time from today's date for accurate comparison
    today.setHours(0, 0, 0, 0);

   if (selectedDate < today && flag != 1 && flag != 2 && flag != 3) {
  toast.error("Cannot enter previous date", {
            duration: 1000,
            position: "top-center",
          });
  formData.date = "";
}



    return (
      <div className="w-full max-w-5xl mx-auto px-6 py-4">
        <Loader
          isVisible={isLoading || isLoadings}
          size="h-20 w-20"
          color="border-t-black"
          blur={true}
        />
        <form class="overflow-auto lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit  sm:max-h-fit">
          <div className="font-semibold pb-2">Check-In Details</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <InputText
              inputType="text"
              title="Booking Id"
              name="bookingId"
              classStar="text-red-500"
              content={formData?.bookingId || ""}
              disabled={true}
              placeholder="BKG-2025-000001"
            />

            <InputText
              inputType="text"
              title="Booked person name"
              name="bookedpersonname"
              classStar="text-red-500"
              content={formData?.fullName || ""}
              disabled={true}
              placeholder="Swetha"
            />

            <InputText
              inputType="date"
              title="Check-in Date"
              name="date"
              classStar="text-red-500"
              content={formData.date || ""}
              controlFunc={handleInputChangeForm}
              controlFuncBlur={handleBlur}
              errorMessage={formErrors.date}
              disabled={flag == 2 || flag == 1 || flag == 3 ? true : false}
            />

            <InputText
              inputType="time"
              title="Check-in Time"
              name="time"
              classStar="text-red-500"
              content={formData.time || ""}
              controlFunc={handleInputChangeForm}
              controlFuncBlur={handleBlur}
              errorMessage={formErrors.time}
              disabled={flag == 2 || flag == 1 || flag == 3 ? true : false}
            />
          </div>
          <table className="w-full border border-gray-300 text-sm mt-4">
            <thead className="bg-[#3D6643] text-white">
              <tr>
                <th className="border px-2 py-2">S.No</th>
                <th className="border px-4 py-2 w-48">Room Type</th>
                <th className="border px-2 py-2">Basic Tariff</th>
                <th className="border px-2 py-2">Spl Tariff</th>
                <th className="border px-2 py-2">No. of Rooms</th>
                <th className="border px-2 py-2">No. of Adults</th>
                <th className="border px-2 py-2">No. of Children</th>
                <th className="border px-2 py-2">Amount</th>
              </tr>
            </thead>
            <tbody>
              {tableDataGrouped.map((row, index) => (
                <tr key={index}>
                  <td className="border px-2 py-2">{index + 1}</td>
                  <td className="border px-4 py-2 w-48 text-align: right;">
                    <DropDown
                      name="roomType"
                      type="select-one"
                      options={[{ value: row.RoomTypeId, label: row.RoomType }]}
                      selectedOption={row.RoomTypeId}
                      controlFunc={(e) => handleInputChange(e, index)}
                      controlFuncBlur={handleBlur}
                      placeholder="Select Villa Type"
                      // // tabIndex="12"
                      disabled={true}
                    />
                  </td>
                  <td className="border px-1 py-2 text-align: right;">
                    <InputText
                      inputType="text"
                      name="basicTariff"
                      content={row.Tariff}
                      placeholder={row.Tariff}
                      disabled={true}
                      // // tabIndex="11"
                      isRequired={true}
                      errorMessage={errors.amount}
                      Class="border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block text-right w-full h-8 px-2 py-1"
                    />
                  </td>
                  <td className="border px-4 py-2 ">
                    <InputText
                      inputType="text"
                      name="specialtariff"
                      controlFunc={(e) => handleInputChangeTable(e, index)}
                      controlFuncBlur={handleBlur}
                      content={row.specialtariff}
                      placeholder=""
                      disabled={flag == 1 || flag == 3 ? true : false}
                      // // tabIndex="11"
                      isRequired={true}
                      errorMessage={errors.amount}
                      Class="border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block text-right w-full h-8 px-2 py-1"
                    />
                  </td>
                  <td className="border px-4 py-2  text-align: right;">
                    <InputText
                      inputType="text"
                      name="Numberofrooms"
                      controlFunc={(e) => handleInputChangeTable(e, index)}
                      controlFuncBlur={handleBlur}
                      content={row.Numberofrooms}
                      placeholder=""
                      disabled={true}
                      // // tabIndex="11"
                      isRequired={true}
                      errorMessage={errors.amount}
                      Class="border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block text-right w-full h-8 px-2 py-1"
                    />
                  </td>
                  <td className="border px-4 py-2 text-align: right;">
                    <InputText
                      inputType="text"
                      name="NumberOfAdults"
                      controlFunc={(e) => handleInputChangeTable(e, index)}
                      controlFuncBlur={handleBlur}
                      content={row.numberofadults}
                      placeholder=""
                      // disabled={true}
                      // // tabIndex="11"
                      isRequired={true}
                      errorMessage={errors.amount}
                      Class="border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block text-right w-full h-8 px-2 py-1"
                    />
                  </td>
                  <td className="border px-1 py-2 text-align: right;">
                    <InputText
                      inputType="text"
                      name="NumberOfChildren"
                      controlFunc={(e) => handleInputChangeTable(e, index)}
                      controlFuncBlur={handleBlur}
                      content={row.numberofchildren}
                      placeholder=""
                      // disabled={true}
                      // // tabIndex="11"
                      isRequired={true}
                      errorMessage={errors.amount}
                      Class="border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block text-right w-full h-8 px-2 py-1"
                    />
                  </td>
                  <td className="border px-1 py-2 text-align: right;">
                    <InputText
                      inputType="text"
                      name="amount"
                      controlFunc={(e) => handleInputChangeTable(e, index)}
                      controlFuncBlur={handleBlur}
                      content={(
                        parseFloat(row.specialtariff || 0) *
                        parseInt(row.Numberofrooms || 0)
                      ).toFixed(2)}
                      placeholder=""
                      disabled={true}
                      // // tabIndex="11"
                      isRequired={true}
                      errorMessage={errors.amount}
                      Class="border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block text-right w-full h-8 px-2 py-1"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className={mainTable.grid3}>
            <div></div>
            <div></div>
            <div className="flex justify-end w-full mt-4">
              <InputText
                title="Total"
                classDiv="flex gap-2 items-center justify-end w-[140px]"
                name="total"
                controlFunc={() => {}} // no-op since it's disabled
                disabled={true}
                content={totalAmount}
                Class="border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block text-right w-full h-8 px-2 py-1"
              />
            </div>
          </div>

          <div className="mx-auto max-w-7xl">
            <ul className="space-y-4">
              {tableDataGrouped?.map((room, index) => (
                <li
                  key={index}
                  className="border border-green-500 rounded-md p-4 shadow-sm bg-white"
                >
                  <div className="flex flex-col mb-2  items-start  justify-between ">
                    {/* Checkbox & Button */}
                    <h2 className="text-lg font-semibold text-gray-800 mb-2">
                      {room.RoomType}
                    </h2>
                    <div className="flex flex-col md:flex-row md:items-start md:gap-x-10">
                      {/* Villa Image */}
                      <img
                        src={room.Photo}
                        alt="Room"
                        className="h-36 w-36 object-cover rounded-md border"
                      />
                      <div>
                        {/* Villa Info */}
                        <div className="flex-1 flex-col w-full">
                          <div className="flex flex-col md:flex-row md:gap-x-24 flex-1">
                            {/* Left Column */}
                            <div className="flex-2 space-y-1">
                              <p className="text-sm text-gray-600">
                                Property Size: {room.Size}
                              </p>
                              <p className="text-sm text-gray-600">
                                Maximum Occupancy: {room.MaxOccupancy}
                              </p>
                              {/* <p className="text-sm text-gray-600">
                              No of Bedrooms: 2
                            </p> */}
                            </div>
                            {/* Right Column */}
                            <div className="flex-2 space-y-1">
                              <p className="text-sm text-gray-600 font-semibold">
                                Space Details
                              </p>
                              {room.SpaceDetails ? (
                                <ul className="text-sm text-gray-600 ">
                                  {room.SpaceDetails.split(",").map(
                                    (item, idx) => (
                                      <li key={idx}>
                                        {idx + 1}. {item.trim()}
                                      </li>
                                    )
                                  )}
                                </ul>
                              ) : (
                                <p className="text-sm text-gray-600 ">
                                  Space Details: Not Available
                                </p>
                              )}
                            </div>

                            <div className="flex-2 space-y-1">
                              <p className="text-sm text-gray-600 font-semibold ">
                                AmenitiesDetails
                              </p>
                              {room.AmenitiesDetails ? (
                                <ul className="text-sm text-gray-600 ">
                                  {room.AmenitiesDetails.split(",").map(
                                    (item, idx) => (
                                      <li key={idx}>
                                        {idx + 1}. {item.trim()}
                                      </li>
                                    )
                                  )}
                                </ul>
                              ) : (
                                <p className="text-sm text-gray-600">
                                  Amenities Details: Not Available
                                </p>
                              )}
                            </div>
                          </div>
                          
                          <div className="">
                            <p className="text-sm font-semibold text-gray-700 mb-2">
                              Rooms: {room.NoOfRequiredRooms}
                            </p>
                            <div className="flex gap-2 flex-wrap">
                              {/* {(room.AvailableRoomsId || "")
                                .split(",")
                                .map((roomIdStr) => {
                                  const roomId = Number(roomIdStr.trim());

                                  // Convert SelectedRoomIds to an array of numbers
                                  const selectedIds = (
                                    room.SelectedRoomIds || ""
                                  )
                                    .split(",")
                                    .map((id) => Number(id.trim()));

                                  const isChecked =
                                    selectedIds.includes(roomId);

                                  return (
                                    <label
                                      key={roomId}
                                      className="cursor-pointer"
                                    >
                                      <input
                                        type="checkbox"
                                        className="hidden"
                                        checked={isChecked}
                                        readOnly
                                      />
                                      <span
                                        className={`border border-black px-3 py-2 text-sm font-medium rounded-md flex items-center justify-center
              ${
                isChecked
                  ? "bg-white text-black border-black cursor-not-allowed"
                  : "bg-green-500 text-white hover:bg-green-600"
              }
            `}
                                      >
                                        {isChecked ? "✔️" : roomId}
                                      </span>
                                    </label>
                                  );
                                })} */}
                                
                                {(room.AvailableRoomsId || "")
  .split(",")
  .map((roomIdStr, idx) => {
    const roomId = Number(roomIdStr.trim());
    if (!roomId) return null;

    // Get corresponding name from AvailableRoomsName
    const names = (room.AvailableRoomsName || "").split(",").map(n => n.trim());
    const roomName = names[idx] || `Room ${roomId}`;

    const selectedIds = (room.SelectedRoomIds || "")
      .split(",")
      .map(id => Number(id.trim()))
      .filter(Boolean);

    const isChecked = selectedIds.includes(roomId);

    return (
      <label key={roomId} className="cursor-pointer">
        <input type="checkbox" className="hidden" checked={isChecked} readOnly />
        <span
          className={`border border-black px-4 py-2 text-sm font-medium rounded-md flex items-center justify-center min-w-[100px]
            ${isChecked
              ? "bg-green-100 text-green-800 border-green-600 cursor-not-allowed"
              : "bg-green-500 text-white hover:bg-green-600"
            }`}
        >
          {isChecked ? "✔️ " : ""}{roomName}
        </span>
      </label>
    );
  })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="border border-green-500" />
                  {groupedData
                    .filter((group) => group.RoomType === room.RoomType) // match only same type
                    .map((group, groupIndex) => (
                      <div key={group.MstRoomId} className="mt-4">
                        <h3 className="text-lg font-bold mb-4 text-gray-800">
                          Guest Details
                        </h3>

                        {group.rooms.map((room, index) => (
                          <div key={room.RoomName} className="mb-6">
                            <h4 className="text-md font-semibold mb-2 text-gray-700">
                              Room: {room.RoomName}
                            </h4>

                            {/* Guest List Section */}
                            <div className="space-y-4">
                              {room.guestList?.map((guest, guestIndex) => (
                                <div
                                  key={guestIndex}
                                  className="border border-gray-300 rounded-lg p-4 bg-white shadow-sm relative"
                                >
                                  {(flag != 3 && flag != 1) && (
                                    <button
                                      type="button"
                                      onClick={() =>
                                        handleClearGuest(groupIndex, guestIndex)
                                      }
                                      className="absolute top-3 right-4 text-red-600 hover:text-red-800 text-xl font-bold"
                                    >
                                      &times;
                                    </button>
                                  )}

                                  <div className="font-medium text-gray-800 mb-2">
                                    {(() => {
                                      const childCount = room.guestList
                                        .slice(0, guestIndex + 1)
                                        .filter((g) => g.isChild).length;
                                      const adultCount = room.guestList
                                        .slice(0, guestIndex + 1)
                                        .filter((g) => !g.isChild).length;

                                      return guest.isChild
                                        ? `Guest Child ${childCount}`
                                        : `Guest Adult ${adultCount}`;
                                    })()}
                                  </div>

                                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-1">
                                    <InputText
                                      title="Guest Name"
                                      name={`guestName-${guestIndex}`}
                                      content={guest.guestName || ""}
                                      disabled={
                                        flag == 1 || flag == 3 ? true : false
                                      }
                                      controlFunc={(e) =>
                                        handleRoomGuestChange(
                                          room.originalIndex,
                                          "guestList",
                                          guestIndex,
                                          "guestName",
                                          e.target.value
                                        )
                                      }
                                    />
                                    <DropDown
                                      title="Gender"
                                      name="gender"
                                      selectedOption={guest.gender || ""}
                                      options={genderOptions}
                                      placeholder="Select"
                                      disabled={
                                        flag == 1 || flag == 3 ? true : false
                                      }
                                      controlFunc={(e) =>
                                        handleRoomGuestChange(
                                          room.originalIndex,
                                          "guestList",
                                          guestIndex,
                                          "gender",
                                          e.target.value
                                        )
                                      }
                                    />
                                    <InputText
                                      title="Age"
                                      name="age"
                                      disabled={
                                        flag == 1 || flag == 3 ? true : false
                                      }
                                      content={guest.age || ""}
                                      controlFunc={(e) =>
                                        handleRoomGuestChange(
                                          room.originalIndex,
                                          "guestList",
                                          guestIndex,
                                          "age",
                                          e.target.value
                                        )
                                      }
                                    />
                                    <DropDown
                                      title="Relationship to the booked person"
                                      name="relationship"
                                      placeholder="Select"
                                      selectedOption={guest.relationship || ""}
                                      disabled={
                                        flag == 1 || flag == 3 ? true : false
                                      }
                                      options={relationshipOptions}
                                      controlFunc={(e) =>
                                        handleRoomGuestChange(
                                          room.originalIndex,
                                          "guestList",
                                          guestIndex,
                                          "relationship",
                                          e.target.value
                                        )
                                      }
                                    />
                                    <DropDown
                                      title="ID Proof Type"
                                      name="idProofType"
                                      placeholder="Select"
                                      disabled={
                                        flag == 1 || flag == 3 ? true : false
                                      }
                                      selectedOption={guest.idProofType || ""}
                                      options={idproofOptions}
                                      controlFunc={(e) =>
                                        handleRoomGuestChange(
                                          room.originalIndex,
                                          "guestList",
                                          guestIndex,
                                          "idProofType",
                                          e.target.value
                                        )
                                      }
                                    />
                                    <InputText
                                      title="ID Proof Number"
                                      name="idProofNumber"
                                      disabled={
                                        flag == 1 || flag == 3 ? true : false
                                      }
                                      content={guest.idProofNumber || ""}
                                      controlFunc={(e) =>
                                        handleRoomGuestChange(
                                          room.originalIndex,
                                          "guestList",
                                          guestIndex,
                                          "idProofNumber",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                  {flag == 1 || flag == 3 ? (
                                    <div className="flex flex-col">
                                      <label className="font-medium text-sm text-gray-700 mb-1">
                                        Guest Photo
                                      </label>
                                      {guest.Photo1 && (
                                        <img
                                          src={guest.Photo1}
                                          alt="Room"
                                          className="h-36 w-36 object-cover rounded-md border"
                                        />
                                      )}
                                    </div>
                                  ) : (
                                    <div className="flex flex-col">
                                      <label className="font-medium text-sm text-gray-700 mb-1">
                                        Guest Photo
                                      </label>
                                      <RadioButton
                                        name={`photoUploadMode-${guestIndex}`}
                                        disabled={
                                          flag == 1 || flag == 3 ? true : false
                                        }
                                        options={[
                                          { label: "Camera", value: 1 },
                                          { label: "Browse", value: 2 },
                                        ]}
                                        selectedOptions={
                                          guest.photoUploadMode ?? 2
                                        }
                                        controlFunc={(value) =>
                                          handleRoomGuestChange(
                                            room.originalIndex,
                                            "guestList",
                                            guestIndex,
                                            "photoUploadMode",
                                            value
                                          )
                                        }
                                      />
                                      {guest.photoUploadMode === 1 ? (
                                        <div className="mt-2">
                                          <CameraComponent
                                            apiCall="CheckInAPI/CheckInGuestPhotoUpload"
                                            modalName="File"
                                            captureLimit={1}
                                            index={room.originalIndex} // ✅ pass parent index
                                            guestIndex={guestIndex} // ✅ pass guest index
                                            showImage={(idx, gIdx, img) =>
                                              handleRoomGuestChange(
                                                idx,
                                                "guestList",
                                                gIdx,
                                                "Photo1",
                                                img
                                              )
                                            }
                                          />
                                        </div>
                                      ) : (
                                        <div className="col-span-3 mt-1">
                                          <FileUpload
                                            // title=""
                                            apiCall="CheckInAPI/CheckInGuestPhotoUpload"
                                            modalName="File"
                                            showImage={guest.Photo1}
                                            showImageData={(fileUrl) =>
                                              handleRoomGuestChange(
                                                room.originalIndex,
                                                "guestList",
                                                guestIndex,
                                                "Photo1",
                                                fileUrl
                                              )
                                            }
                                            imageShow={false}
                                            disabledBtn={
                                              flag == 2 ? true : false
                                            }
                                            clear={fileClear}
                                            imageUploadedError={
                                              formErrors.showImageError
                                            }
                                            limitMassage={
                                              "Image size limit: 2MB. Accepted Image types:jpg, png, jpeg."
                                            }
                                            MAX_FILE_SIZE_MB={2}
                                            ALLOWED_FORMATS={[
                                              "image/jpeg",
                                              "image/jpg",
                                              "image/png",
                                            ]}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>

                            {/* Additional Occupancy */}
                            <div className="relative border border-gray-300 rounded-lg p-4 bg-white shadow-sm mb-4 mt-4">
                             {(flag != 3 && flag != 1) && ( <button
                                type="button"
                                onClick={() =>
                                  handleClearAdditionalDetails(groupIndex)
                                }
                                className="absolute top-2 right-2 text-gray-500 hover:text-red-600 text-lg font-bold"
                              >
                                &times;
                              </button>)}
                              <h3 className="text-md font-semibold mb-2 text-gray-700">
                                Additional Occupancy
                              </h3>
                              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
                                <InputText
                                  inputType="number"
                                  title="Adult"
                                  name="adultname"
                                  disabled={
                                    flag == 1 || flag == 3 ? true : false
                                  }
                                  content={
                                    room.additionalDetails?.adultname || ""
                                  }
                                  controlFunc={(e) =>
                                    handleRoomAdditionalChange(
                                      groupIndex,
                                      "adultname",
                                      e.target.value
                                    )
                                  }
                                />
                                <InputText
                                  title="Child"
                                  name="childernname"
                                  disabled={
                                    flag == 1 || flag == 3 ? true : false
                                  }
                                  content={
                                    room.additionalDetails?.childernname || ""
                                  }
                                  controlFunc={(e) =>
                                    handleRoomAdditionalChange(
                                      groupIndex,
                                      "childernname",
                                      e.target.value
                                    )
                                  }
                                />
                                <InputText
                                  title="Charges"
                                  name="charges"
                                  disabled={
                                    flag == 1 || flag == 3 ? true : false
                                  }
                                  content={
                                    room.additionalDetails?.charges || ""
                                  }
                                  controlFunc={(e) =>
                                    handleRoomAdditionalChange(
                                      groupIndex,
                                      "charges",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ))}
                </li>
              ))}
            </ul>
          </div>
          <hr className="border border-green-500 my-4" />
          <h3 className="text-md font-semibold mb-2 text-gray-700">
            Room Booking Payment Details
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 pt-4 gap-4">
            <div>Total Amount : {formData.bookingTotalAmount || 0}</div>
            <div>Received Amount : {formData.bookingReceivedAmount || 0}</div>
            <div>Balance Amount : {formData.bookingBalanceAmount || 0}</div>
          </div>
          <hr className="border border-green-500 my-4" />
          <h3 className="text-md font-semibold mb-2 text-gray-700">
            Check In Payment Details
          </h3>
          <div className={mainTable.grid4}>
            <InputText
              inputType="number"
              title="Total Amount"
              name="totalAmount"
              disabled={true}
              // content={totalAmount || ""}
              content={checkInTotalAmount}
              controlFunc={handleInputChangeForm}
              controlFuncBlur={handleBlur}
              classStar="text-red-500"
              errorMessage={formErrors.totalAmount}
            />

            <InputText
              inputType="number"
              title="Received Amount"
              disabled={flag == 1 || flag == 3 ? true : false}
              name="receivedAmout" // keep as is if you use this key in your DB
              content={formData.receivedAmout || ""}
              controlFunc={handleInputChangeForm}
              controlFuncBlur={handleBlur}
              // classStar="text-red-500"
              // errorMessage={formErrors.receivedAmout}
            />

            <InputText
              inputType="number"
              title="Balance Amount"
              name="balanceAmount"
              disabled={true}
              content={formData.balanceAmount || 0}
              controlFunc={handleInputChangeForm}
              controlFuncBlur={handleBlur}
              errorMessage={formErrors.totalAmount}
            />

            <DropDown
              title="Payment Type"
              name="paymentmethod"
              placeholder="Select"
              disabled={flag == 1 || flag == 3 ? true : false}
              options={paymentTypeOptions}
              selectedOption={formData.paymentmethod || ""}
              controlFunc={(e) =>
                handleInputChangeForm({
                  target: { name: "paymentmethod", value: e.target.value },
                })
              }
              controlFuncBlur={handleBlur}
            />

            <InputText
              inputType="text"
              title="Payment Reference Number"
              name="referencenumber"
              disabled={flag == 1 || flag == 3 ? true : false}
              content={formData.referencenumber || ""}
              controlFunc={handleInputChangeForm}
            />
            {flag == 1 || flag == 3 ? (
              <div>
                {formData.showImage && (
                  <img
                    src={formData.showImage}
                    alt="Room"
                    className="h-36 w-36 object-cover rounded-md border"
                  />
                )}
              </div>
            ) : (
              <div className="flex col-span-3 flex-col">
                <FileUpload
                  title="File Upload"
                  apiCall="CheckInAPI/CheckInRefernceFileUpload"
                  modalName="File"
                  showImage={formData.showImage}
                  showImageData={handleShowImage}
                  imageShow={false}
                  disabledBtn={flag == 2 ? true : false}
                  clear={fileClear}
                  imageUploadedError={formErrors.showImageError}
                  limitMassage={
                    "Image size limit: 2MB. Accepted Image types:jpg, png, jpeg."
                  }
                  MAX_FILE_SIZE_MB={2}
                  ALLOWED_FORMATS={["image/jpeg", "image/jpg", "image/png"]}
                />
              </div>
            )}
          </div>
        </form>
      </div>
    );
  }
);

export default Checkinpopup;
